import { defineMessages } from "react-intl";

const baseId = "t.components.modals.doubleDateModal.";

export default defineMessages({
  title: {
    id: baseId + "title",
    defaultMessage: "Modify validity",
  },
  date: {
    id: baseId + "date",
    defaultMessage: "Date",
  },
  startDate: {
    id: baseId + "startDate",
    defaultMessage: "Start Date",
  },
  finishDate: {
    id: baseId + "finishDate",
    defaultMessage: "Finish Date",
  },
  confirm: {
    id: baseId + "confirm",
    defaultMessage: "Confirm",
  },
  cancel: {
    id: baseId + "cancel",
    defaultMessage: "Cancel",
  },
  nullEndDate: {
    id: baseId + "nullEndDate",
    defaultMessage: "End Date can't be in the past",
  },
});
